﻿import { Injectable } from '@angular/core';
import { SessionStorageService } from '../../../../shared/session/session-storage/session-storage.service';
import { SessionableMortgageDataModel } from '../../../sessionable-mortgage-data-model';
import { MortgageCoborrowerData } from '../../../interfaces/mortgage-borrower-data.interface';

@Injectable()
export class MortgageCoBorrowerDataModel extends SessionableMortgageDataModel implements MortgageCoborrowerData {

  // Data that is saved to session storage
  private _borrowerGuid: string;
  private _borrowerId: string;
  private _firstName: string;
  private _lastName: string;
  private _email: string;

  constructor(protected sessionStorageService: SessionStorageService) {
    super(sessionStorageService);
  }

  public populate(coBorrower?: MortgageCoBorrowerDataModel): MortgageCoBorrowerDataModel {
    const map = (mapping: (data: MortgageCoBorrowerDataModel) => string) => {
      return coBorrower ? mapping(coBorrower) : '';
    };

    this._borrowerGuid = map(x => x._borrowerGuid);
    this._borrowerId = map(x => x._borrowerId);
    this._firstName = map(x => x._firstName);
    this._lastName = map(x => x._lastName);
    this._email = map(x => x._email);

    return this;
  }

  protected map(model: any): MortgageCoBorrowerDataModel {
    return model._borrowerData._coBorrowerData;
  }

  protected save(setter: (model: MortgageCoBorrowerDataModel) => void): void {
    super.save(setter);
  }

  public set borrowerGuid(value: string) {
    this._borrowerGuid = value;
    this.save(x => x._borrowerGuid = value);
  }

  public get borrowerGuid(): string {
    return this._borrowerGuid;
  }

  public set borrowerId(value: string) {
    this._borrowerId = value;
    this.save(x => x._borrowerId = value);
  }

  public get borrowerId(): string {
    return this._borrowerId;
  }

  public set firstName(value: string) {
    this._firstName = value;
    this.save(x => x._firstName = value);
  }

  public get firstName(): string {
    return this._firstName;
  }

  public set lastName(value: string) {
    this._lastName = value;
    this.save(x => x._lastName = value);
  }

  public get lastName(): string {
    return this._lastName;
  }

  public set email(value: string) {
    this._email = value;
    this.save(x => x._email = value);
  }

  public get email(): string {
    return this._email;
  }

  public clear(): void {
    this.populate(null);

    this.borrowerGuid = '';
    this.borrowerId = '';
    this.email = '';
    this.firstName = '';
    this.lastName = '';
  }
}
